import { ReportReferral } from '@/app/services/reportService/reportReferral'
import { formatCpfNumber } from '@/app/utils/cpfFormater'
import { formatName } from '@/app/utils/formatName'
import { formatPhoneNumber } from '@/app/utils/formatPhoneNumber'
import { createColumnHelper } from '@tanstack/react-table'
import { format } from 'date-fns'

const columnHelper = createColumnHelper<ReportReferral>()

const columns = [
  columnHelper.accessor('name', {
    id: 'name',
    header: () => (
      <div className="flex w-full flex-col items-start gap-1 pl-2">
        <div>Nome</div>
        <div className="block text-black04 xl:hidden">CPF</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex w-full flex-col items-start gap-1 pl-4">
        <div>{formatName(row.original.name)}</div>
        <div className="block text-black04 xl:hidden">
          {formatCpfNumber(row.original.cpf) || ''}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('cpf', {
    id: 'cpf',
    header: () => <div className="hidden text-left xl:block">CPF</div>,
    cell: ({ row }) => (
      <div className="hidden text-left xl:block">
        {formatCpfNumber(row.original.cpf) || ''}
      </div>
    ),
  }),
  columnHelper.accessor('email', {
    id: 'email',
    header: () => <div className="hidden text-left lg:block">E-mail</div>,
    cell: ({ row }) => (
      <div className="hidden text-left lg:block">
        {row.original.email || ''}
      </div>
    ),
  }),
  columnHelper.accessor('phone', {
    id: 'phone',
    header: () => (
      <div className="flex w-full flex-col items-end gap-1 pr-2 sm:items-center sm:pr-0">
        <div>Telefone</div>
        <div className="block text-black04 lg:hidden">E-mail</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex w-full flex-col items-end gap-1 pr-4 sm:items-center sm:pr-0">
        <div>
          {row.original.phone ? formatPhoneNumber(row.original.phone) : '-'}
        </div>
        <div className="block text-black04 lg:hidden">
          {row.original.email || ''}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('createdAt', {
    id: 'createdAt',
    header: () => (
      <div className=" hidden text-center md:block ">Indicado em</div>
    ),
    cell: ({ row }) => (
      <div className=" hidden text-center md:block">
        {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
      </div>
    ),
  }),
  columnHelper.accessor('registered', {
    id: 'registered',
    header: () => (
      <div className="hidden sm:block">
        <div className="flex w-full flex-col items-end gap-1 pr-2">
          <div>Cadastrado?</div>
          <div className="text-center text-black04 md:hidden ">Indicado em</div>
        </div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="hidden sm:block">
        <div className="flex w-full flex-col items-end gap-1 pr-4">
          <div>
            {row.original.registered ? (
              <span className="flex items-baseline gap-2">
                <i className="fa-solid fa-circle-check text-sm text-success" />
                {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
              </span>
            ) : (
              <span className="flex items-baseline gap-2">
                <i className="fa-solid fa-circle-exclamation text-error" />
                NÃO
              </span>
            )}
          </div>
        </div>
      </div>
    ),
  }),
]

export const TableReportReferralColumnsDefinition = () => {
  return {
    columns,
  }
}
